import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  month,
  setMonth,
  year,
  setYear,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  applyFilters,
  removeFilters,

  companyFilter = [],
  setCompanyFilter = () => {},

  feetFilter = [],
  setFeetFilter = () => {},

  companyOptions = [],
  feetOptions = [],

  apidata = [],
  hubFilter = [],
  setHubFilter = () => {},
  statusFilter = [],
  setStatusFilter = () => {},

  leasingPartnerFilter = [],
  setLeasingPartnerFilter = () => {},

  leasingPartnerOptions = [],
}) {
  const [hubSearch, setHubSearch] = React.useState("");
  const [companySearch, setCompanySearch] = React.useState("");
  const [feetSearch, setFeetSearch] = React.useState("");
  const [leasingPartnerSearch, setLeasingPartnerSearch] = React.useState("");
  const statusOptions = ["Active", "Inactive", "Unassigned", "Service_Center"];
  const currentYear = new Date().getFullYear();

  /* =========================
     HUB LIST
  ========================= */

  const hubList = Array.from(
    new Set(
      (apidata || []).flatMap((item) =>
        Object.keys(item?.hubSummary || {}).map((hub) => hub.trim()),
      ),
    ),
  ).sort((a, b) => a.localeCompare(b));

  /* =========================
     FILTER COMPANY OPTIONS
  ========================= */

  const filteredCompanyOptions = companyOptions
    .filter((company) =>
      company.toLowerCase().includes(companySearch.toLowerCase()),
    )
    .sort((a, b) => a.localeCompare(b));

  /* =========================
     FILTER FEET OPTIONS
  ========================= */

  const filteredFeetOptions = feetOptions
    .filter((feet) =>
      String(feet).toLowerCase().includes(feetSearch.toLowerCase()),
    )
    .sort((a, b) => a - b);

  const filteredLeasingPartnerOptions = leasingPartnerOptions
    .filter((partner) =>
      partner.label?.toLowerCase().includes(leasingPartnerSearch.toLowerCase()),
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  /* =========================
     YEARS
  ========================= */

  const years = [];

  for (let i = currentYear; i >= currentYear - 5; i--) {
    years.push(i);
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* =========================
              MONTH
          ========================= */}

          <Form.Group className="mb-2">
            <Form.Label>Month</Form.Label>

            <Form.Select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option value="">Select Month</option>

              {Array.from({ length: 12 }).map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* =========================
              YEAR
          ========================= */}

          <Form.Group className="mb-2">
            <Form.Label>Year</Form.Label>

            <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
              <option value="">Select Year</option>

              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* =========================
              FROM DATE
          ========================= */}

          <Form.Group className="mb-2">
            <Form.Label>From Date</Form.Label>

            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          {/* =========================
              TO DATE
          ========================= */}

          <Form.Group className="mb-2">
            <Form.Label>To Date</Form.Label>

            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          {/* =========================
    STATUS FILTER
========================= */}

          <Form.Group className="mt-3">
            <Form.Label>Status</Form.Label>

            <div
              className="border rounded p-2"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              {statusOptions.map((status) => (
                <Form.Check
                  key={status}
                  type="checkbox"
                  label={
                    status === "Service_Center" ? "Service Center" : status
                  }
                  value={status}
                  checked={statusFilter.includes(status)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setStatusFilter([...statusFilter, status]);
                    } else {
                      setStatusFilter(
                        statusFilter.filter((item) => item !== status),
                      );
                    }
                  }}
                  className="mb-1"
                />
              ))}
            </div>
          </Form.Group>

          {/* =========================
              COMPANY FILTER
          ========================= */}

          <Form.Group className="mt-3">
            <Form.Label>Company</Form.Label>

            {/* 🔍 COMPANY SEARCH */}

            <Form.Control
              type="text"
              placeholder="Search company..."
              value={companySearch}
              onChange={(e) => setCompanySearch(e.target.value)}
              className="mb-2"
            />

            <div
              className="border rounded p-2"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              {filteredCompanyOptions.length > 0 ? (
                filteredCompanyOptions.map((company) => (
                  <Form.Check
                    key={company}
                    type="checkbox"
                    label={company}
                    value={company}
                    checked={companyFilter.includes(company)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCompanyFilter([...companyFilter, company]);
                      } else {
                        setCompanyFilter(
                          companyFilter.filter((item) => item !== company),
                        );
                      }
                    }}
                    className="mb-1"
                  />
                ))
              ) : (
                <small className="text-muted">No company found</small>
              )}
            </div>
          </Form.Group>

          {/* =========================
              VEHICLE FEET FILTER
          ========================= */}

          <Form.Group className="mt-3">
            <Form.Label>Vehicle Feet</Form.Label>

            {/* 🔍 FEET SEARCH */}

            <Form.Control
              type="text"
              placeholder="Search feet..."
              value={feetSearch}
              onChange={(e) => setFeetSearch(e.target.value)}
              className="mb-2"
            />

            <div
              className="border rounded p-2"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              {filteredFeetOptions.length > 0 ? (
                filteredFeetOptions.map((feet) => (
                  <Form.Check
                    key={feet}
                    type="checkbox"
                    label={`${feet} Feet`}
                    value={feet}
                    checked={feetFilter.includes(feet)}
                    onChange={(e) => {
                      const value = Number(e.target.value);

                      if (e.target.checked) {
                        setFeetFilter([...feetFilter, value]);
                      } else {
                        setFeetFilter(
                          feetFilter.filter((item) => item !== value),
                        );
                      }
                    }}
                    className="mb-1"
                  />
                ))
              ) : (
                <small className="text-muted">No feet option found</small>
              )}
            </div>
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Leasing Partner</Form.Label>

            {/* 🔍 LEASING PARTNER SEARCH */}
            <Form.Control
              type="text"
              placeholder="Search leasing partner..."
              value={leasingPartnerSearch}
              onChange={(e) => setLeasingPartnerSearch(e.target.value)}
              className="mb-2"
            />

            <div
              className="border rounded p-2"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              {filteredLeasingPartnerOptions.length > 0 ? (
                filteredLeasingPartnerOptions.map((partner) => (
                  <Form.Check
                    key={partner.value}
                    type="checkbox"
                    label={partner.label}
                    value={partner.value}
                    checked={leasingPartnerFilter.includes(partner.value)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setLeasingPartnerFilter([
                          ...leasingPartnerFilter,
                          partner.value,
                        ]);
                      } else {
                        setLeasingPartnerFilter(
                          leasingPartnerFilter.filter(
                            (item) => item !== partner.value,
                          ),
                        );
                      }
                    }}
                    className="mb-1"
                  />
                ))
              ) : (
                <small className="text-muted">No leasing partner found</small>
              )}
            </div>
          </Form.Group>

          {/* =========================
              HUB FILTER
          ========================= */}

          {hubList.length > 0 && (
            <Form.Group className="mt-3">
              <Form.Label>Hubs</Form.Label>

              {/* 🔍 HUB SEARCH */}

              <Form.Control
                type="text"
                placeholder="Search hub..."
                value={hubSearch}
                onChange={(e) => setHubSearch(e.target.value)}
                className="mb-2"
              />

              <div
                className="border rounded p-2"
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {hubList
                  .filter((hub) =>
                    hub.toLowerCase().includes(hubSearch.toLowerCase()),
                  )
                  .map((hub, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      label={hub}
                      value={hub}
                      checked={hubFilter.includes(hub)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setHubFilter([...hubFilter, hub]);
                        } else {
                          setHubFilter(hubFilter.filter((h) => h !== hub));
                        }
                      }}
                      className="mb-1"
                    />
                  ))}
              </div>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>

      {/* =========================
          FOOTER
      ========================= */}

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setCompanySearch("");
            setFeetSearch("");
            setHubSearch("");
            setLeasingPartnerSearch("");
            removeFilters();
          }}
        >
          Remove Filters
        </Button>

        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
